<!--
* @description  参数1
* @fileName  Summary
* @author userName
* @date 2024-01-29 11:59:42
!-->
<template>
  <div id="Summary" class="Summary">
    <div class="list-item">
      <div class="title">GOODS</div>
      <div class="lable-item">
        <div class="lable">Total Weight</div>
        <span class="content">{{ data.weight }} KG</span>
      </div>
      <div class="lable-item">
        <div class="lable">Total Volume</div>
        <span class="content">{{ data.volume }} CBM</span>
      </div>
      <div class="lable-item">
        <div class="lable">Chargeable Weight</div>
        <span class="content">{{ data.orderChargeWeight }} {{ data.countMode===3?'CBM':'KG' }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Commodities</div>
        <span class="content">{{ data.commoditiesName }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Value</div>
        <span class="content">US ${{ data.cargoValue }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Ready For Pickup</div>
        <span v-if="!isEditTime" class="content" @click="eidtTime">{{ data.goodsReadyTime }}</span>
        <el-date-picker
          v-if="isEditTime"
          v-model="goodsReadyTime"
          type="date"
          placeholder=""
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          style="width: 70%;"
          @change="saveTime"
        />
        <span v-if="isEditTime" class="content-cancel" @click="eidtTimeCancel">cancel</span>
      </div>
    </div>
    <div class="list-item">
      <div class="title">Route</div>
      <div class="lable-item">
        <div class="lable">Route</div>
        <span class="content">{{ data.startCityNameEn }}, {{ data.startCountryNameEn }} >
          {{ data.destCityNameEn }}, {{ data.destProvinceNameEn }}, {{ data.destCountryNameEn }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Mode</div>
        <span class="content">EXPRESS</span>
      </div>
      <div class="lable-item">
        <div class="lable">Service Type</div>
        <span class="content">Door to door</span>
      </div>
      <div class="lable-item">
        <div class="lable">Est. Transit Time</div>
        <span class="content">{{ data.workDays }} days</span>
      </div>
    </div>
    <div class="list-item">
      <div class="title">BOOKING DETAILS</div>
      <div class="lable-item">
        <div class="lable">Shipment ID</div>
        <span class="content">{{ data.orderNo }}
        </span>
      </div>
      <div class="lable-item">
        <div class="lable">Rate Valid Until</div>
        <span class="content">{{ data.priceEndTime }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Booked On</div>
        <span class="content">{{ data.creatorTimeStr }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Booked By</div>
        <span class="content">{{ data.customerName }}</span>
      </div>
    </div>
    <div class="list-item">
      <div class="title">REQUESTED SERVICES</div>
      <slot v-if="data.buyInsurance==1">
        <div class="title">Insurance</div>
        <div class="lable-item">
          <div class="lable">Goods value</div>
          <span class="content">US${{ data.cargoValue }}</span>
        </div>
        <div class="lable-item">
          <div class="lable">Provider</div>
          <span class="content">{{ data.insuranceInfo.insuranceName }}</span>
        </div>
      </slot>
      <div v-if="data.isLiftgateDelivery==1" class="title">Liftgate Delivery</div>
    </div>
  </div>
</template>

<script>
import {
  UpdateGoodsReadyTime,
  GetExpOrderDetail
} from '@/api/order.js'
export default {
  name: 'Summary',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      data: {},
      isEditTime: false,
      goodsReadyTime: undefined
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
	  eidtTimeCancel() {
	    this.isEditTime = false
	  },
    eidtTime() {
      this.isEditTime = true
    },
    saveTime(val) {
      UpdateGoodsReadyTime({
        orderNo: this.data.orderNo,
        goodsReadyTime: val
      }).then(res => {
        if (res.code === 200) {
          this.isEditTime = false
          this.initOrder(this.data.orderNo)
        }
      })
    },
    init(data) {
      this.data = data
      this.goodsReadyTime = new Date(this.data.goodsReadyTime)
    },
    initOrder(orderNo) {
      GetExpOrderDetail(orderNo).then(res => {
        if (res.code === 200) {
          this.data = res.data
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.Summary {
		display: flex;
		flex-wrap: wrap;
		width: auto;
		padding: 0 8px;

		.list-item {
			width: 524px;
			height: 256px;
			background: rgba(0, 0, 0, 0.02);
			border-radius: 8px;
			padding: 8px 16px;
			margin: 12px 16px;
			text-align: left;

			.title {
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				color: #333333;
				height: 32px;
				line-height: 32px;
			}

			.lable-item {
				display: flex;
				height: 32px;
				align-items: center;

				.lable {
					font-size: 13px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #666666;
					width: 132px;
				}

				.content {
					font-size: 13px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #333333;
				}
				.content-cancel {
					color: #E95506;
					margin-left: 10px;
					cursor: pointer;
				}
			}
		}
	}
</style>
